var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstruments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.83,
    height: 17.96,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tools -") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m3.52,6.24l0,1.88l0.55,0l0,9.88l-1.88,0l0,-9.88l0.55,0l0,-1.88a3.13,3.13 0 1 1 0.78,0z",
    className: "cls-1",
    id: "Path_161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.18,3.79l0,1.69l0.17,0l0,2.64l0.55,0l0,9.88l-1.9,0l0,-9.88l0.55,0l0,-2.64l0.18,0l0,-2.12l0.27,0a1.42,1.42 0 0 0 0,-2.84l0,-0.44a1.86,1.86 0 0 1 0.22,3.71l-0.04,0z",
    className: "cls-1",
    id: "Path_162"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruments);
export default __webpack_public_path__ + "static/media/instruments.f8fa83fc45f14240506b9dc301620554.svg";
export { ForwardRef as ReactComponent };